import styled from 'styled-components';

export const DivDescricaoSobreMim = styled.div`

    >p{
        font-size: 20px;
        margin-bottom:40px;
    }
`;
